module.exports = __webpack_public_path__ + "assets/img/hontoyutari.de684de1.png";